import React from 'react';

// Local Components
import Separator from '../FormFields/Separator';
import VenueListCarousel from './VenueListCarousel';
import VenueSelection from './VenueSelection';
import VenueCard from '../Cards/VenueCard';
import BackToTop from '../Buttons/BackToTop';

// Typography
import { H2 } from '../../themes/typography';

// CSS Styles
import '../../styles/components/VenueDiscovery.css';

export default function VenueDiscovery() {
    return (
        <React.Fragment>
            <div className="main-venue-discovery-page">
                <div className="venue-discovery-listing-container">
                    {/* Venue Heading */}
                    {/* <div className="venue-discovery-location-name">
                        <H2 color="#f8a21e" fontWeight={600}>Venues in Surat</H2>
                        <Separator />
                    </div> */}

                    {/* Venue Selection */}
                    <div className="discover-your-scene-container">
                        <VenueSelection />
                    </div>

                    {/* Venue Listing Section */}
                    <div className="venues-discovery-grid-container">
                        {/* Food & Drinks Venues */}
                        <VenueListCarousel
                            venueCategory="Food & Drinks"
                            seeAllList="/food-and-drinks"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Sports & Fitness */}
                        <VenueListCarousel
                            venueCategory="Sports & Fitness"
                            seeAllList="/sports-and-fitness"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Business & Professional */}
                        <VenueListCarousel
                            venueCategory="Business & Professional"
                            seeAllList="/business-and-professional"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Auditoriums */}
                        <VenueListCarousel
                            venueCategory="Auditoriums"
                            seeAllList="/auditoriums"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Studios */}
                        <VenueListCarousel
                            venueCategory="Studios"
                            seeAllList="/studios"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Halls*/}
                        <VenueListCarousel
                            venueCategory="Halls"
                            seeAllList="/halls"
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />

                        {/* Party Plots */}
                        <VenueListCarousel
                            venueCategory="Party Plots"
                            seeAllList="/party-plots"
                            showSeparator={false}
                            venueLists={Array.from({ length: 6 }).map((_, index) => (
                                <div key={index}>
                                    <VenueCard />
                                </div>
                            ))}
                        />
                    </div>
                </div>
            </div>

            {/* BackToTop */}
            <BackToTop />
        </React.Fragment>
    );
}

// Add Venue Carousel Before Venue Selection Section Starts
